import { render, staticRenderFns } from "./CSCCustomAnswerDlg.vue?vue&type=template&id=24d832ac&"
import script from "./CSCCustomAnswerDlg.vue?vue&type=script&lang=js&"
export * from "./CSCCustomAnswerDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports